<template>
  <div>
    <div class="row-fluid">
      <spinner :visible="isLoading"></spinner>

      <div class="row-fluid report-item-row" v-for="(report, index) in reports" :key="index">
        <report-print-row :label="report.label" :data="report.data"></report-print-row>
      </div>
    </div>
  </div>
</template>
<script>
import spinner from '../spinner';
import apiConnector from '@/epersonam/apiConnector';
import reportPrintRow from '../menu_reports/reportPrintRow';
import { Route } from '../../route';

export default {
  name: 'dataExtractionMenu',
  components: {
    spinner,
    reportPrintRow,
  },
  props: [],
  data() {
    return {
      isLoading: false,
      reports: [],
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  mounted() {
    this.isLoading = true;
    apiConnector()
      .get(`${Route.REPORT}/csv_data_extraction_models.json`)
      .then((res) => {
        this.isLoading = false;
        this.reports = res.data;
      });
  },
  methods: {},
};
</script>
<style lang="scss" scoped></style>
